import { createFileRoute } from "@tanstack/react-router"

import { ReceiptRouteComponent } from "@/routes/receipt/$receiptID"

export const Route = createFileRoute("/qr/$qrLookupID/receipt/$receiptID")({
  component: RouteComponent,
})

function RouteComponent() {
  const { receiptID } = Route.useParams()
  return <ReceiptRouteComponent receiptID={receiptID} />
}
